import * as React from 'react';
import { ProductVideo as Video } from 'Common/components/ui';

const isIOS = navigator?.platform ? /iphone|ipod|ipad/i.test(navigator.platform) : false;

export default function ProductVideo(props) {
    return <Video {...props} isIOS={isIOS} />;
}
